import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  missive: defineAsyncComponent(() => import("/vercel/path0/layouts/missive.vue").then(m => m.default || m))
}